import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Response } from '../queries/getQuizQuery';
import { useGetLeaderReportPdfQuery } from './SurveyResponse/queries/getLeaderReportPdfQuery';

type Props = {
  readonly quiz: Response['quiz'];
};

export default function DownloadTeamReport({ quiz }: Props) {
  const [fetchReportUrl, { loading }] = useGetLeaderReportPdfQuery({
    variables: { quizId: quiz.id },
  });

  const handleGeneratePdf = async () => {
    if (loading) return;
    const reportResonse = await fetchReportUrl();
    const reportFileUrl =
      await reportResonse?.data?.getLeaderReportPdf?.reportUrl;
    window.open(reportFileUrl, '_blank');
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!quiz.isTeamReportApproved) {
    return (
      <div>
        <button
          onClick={handleGeneratePdf}
          className="bg-gray-300 text-white px-3 py-1 rounded shadow"
          disabled={true}
        >
          <FontAwesomeIcon icon="file-pdf" />
          <span>Download Team report</span>
        </button>
      </div>
    );
  }
  return (
    <div>
      {quiz.reportUrl ? (
        <a
          href={quiz.reportUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="bg-gray-600 text-white px-3 py-1 inline-block rounded shadow hover:bg-gray-700"
        >
          <FontAwesomeIcon icon="download" />
          <span>Download Team report</span>
        </a>
      ) : (
        <button
          onClick={handleGeneratePdf}
          className="bg-gray-600 text-white px-3 py-1 rounded shadow hover:bg-gray-700"
        >
          <FontAwesomeIcon icon="file-pdf" />
          <span>Download Team report</span>
        </button>
      )}
    </div>
  );
}
